module.exports = __webpack_public_path__ + "assets/images/Sample1.de50d426.jpg";